import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
import { jsx, Fragment } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import theme from '../../theme/index.js';
import '../../../../authentication/context/AuthenticationProvider.js';
import '@geit/ui-components';
import 'react';
import { useNavigate } from '../../../../authentication/hooks/useNavigate.js';
import 'qs';
import 'uuid';
import '../../../../authentication/navigate.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SCAnchor = styled.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n  cursor: pointer;\n  outline: 0;\n  white-space: nowrap;\n\n  &[disabled] {\n    color: ", ";\n    cursor: default;\n  }\n\n  &:not([disabled]) {\n    &:hover {\n      ", "\n      text-decoration: none;\n    }\n  }\n\n  font-family: ", ";\n"])), theme.colours.linkblue, theme.colours.grey_cc, _ref => {
  let {
    noHoverColor
  } = _ref;
  return !noHoverColor && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), theme.colours.bluehover);
}, theme.fonts.families.LatoHeavy);
const SCAnchorWithoutHref = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
const Anchor = _ref2 => {
  let {
    disabled,
    onClick,
    className,
    id,
    role,
    ariaLabel,
    target,
    title,
    tabIndex,
    href,
    children,
    noHoverColor
  } = _ref2;
  const navigate = useNavigate();
  const handleClick = e => {
    e.preventDefault();
    if (!disabled) {
      onClick == null ? void 0 : onClick(e);
      if (href) {
        navigate(href);
      }
    }
  };
  const anchorProps = {
    className,
    id,
    role,
    "aria-label": ariaLabel,
    target,
    title,
    tabIndex,
    onClick: handleClick,
    disabled,
    noHoverColor
  };
  return /* @__PURE__ */jsx(Fragment, {
    children: href ? /* @__PURE__ */jsx(SCAnchor, __spreadProps(__spreadValues({
      href
    }, anchorProps), {
      children
    })) : /* @__PURE__ */jsx(SCAnchorWithoutHref, __spreadProps(__spreadValues({}, anchorProps), {
      children
    }))
  });
};
export { Anchor as default };